"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkBlockTimesResponseMainnetToJSON = exports.NetworkBlockTimesResponseMainnetFromJSONTyped = exports.NetworkBlockTimesResponseMainnetFromJSON = void 0;
function NetworkBlockTimesResponseMainnetFromJSON(json) {
    return NetworkBlockTimesResponseMainnetFromJSONTyped(json, false);
}
exports.NetworkBlockTimesResponseMainnetFromJSON = NetworkBlockTimesResponseMainnetFromJSON;
function NetworkBlockTimesResponseMainnetFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'target_block_time': json['target_block_time'],
    };
}
exports.NetworkBlockTimesResponseMainnetFromJSONTyped = NetworkBlockTimesResponseMainnetFromJSONTyped;
function NetworkBlockTimesResponseMainnetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'target_block_time': value.target_block_time,
    };
}
exports.NetworkBlockTimesResponseMainnetToJSON = NetworkBlockTimesResponseMainnetToJSON;
//# sourceMappingURL=NetworkBlockTimesResponseMainnet.js.map